export default __webpack_public_path__ + "static/media/IbaneraBounce.7f7e6eba.gif";